import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Modal, Checkbox, CircularProgress, Typography, Box, IconButton } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Iconify from 'src/components/iconify';
import Services from 'src/services/Services';

export default function BolParaEsnafPackageInfo() {
  const { companyID, campaignID } = useParams(); // ✅ companyID de gerekli
  const parsedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const token = parsedUser?.token;

  const [campaign, setCampaign] = useState(null);
  const [agreements, setAgreements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [poiID, setPoiID] = useState('');

  // ✅ Şartlar
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [currentAgreementIndex, setCurrentAgreementIndex] = useState(0);

  // ✅ Kupon akışı
  const [campaignHasCoupon, setCampaignHasCoupon] = useState(null); // null: yükleniyor
  const [campaignHadCoupon, setCampaignHadCoupon] = useState(null);  // tükendi mi bilgisi için
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [couponData, setCouponData] = useState(null);
  const [couponModalOpen, setCouponModalOpen] = useState(false);

  // Kampanya ve sözleşmeler
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const res = await Services.GetBolParaCampaign(token, campaignID);
        if (res?.data?.status) {
          setCampaign(res.data.result);
          const agr = await Services.GetBolParaAgreement(token, campaignID);
          if (agr?.data?.status) setAgreements(agr.data.result);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAll();
  }, [token, campaignID]);

  useEffect(() => {
    Services.BolParaAboutToken(token)
      .then((res) => {
        if (res?.data?.status) {
          setPoiID(res.data.result?.easypointID || '');
        } else {
          setPoiID('');
        }
      })
      .catch(() => setPoiID(''));
  }, []);

  // Bu kampanyada kupon var mı?
  const checkThisCampaignHasCoupon = () => {
    setCampaignHasCoupon(null);
    setCampaignHadCoupon(null);
    Services.GetBolParaCampaignHasCoupon(token, campaignID)
      .then((res) => {
        const ok = res?.data?.status === true;
        if (!ok) {
          setCampaignHasCoupon(false);
          setCampaignHadCoupon(false);
          return;
        }
        const result = res?.data?.result;
        if (result && typeof result === 'object') {
          setCampaignHasCoupon(Boolean(result.hasCoupon));
          setCampaignHadCoupon(Boolean(result.hadCoupon));
        } else {
          // result yoksa "kupon var" varsay
          setCampaignHasCoupon(true);
          setCampaignHadCoupon(true);
        }
      })
      .catch(() => {
        setCampaignHasCoupon(false);
        setCampaignHadCoupon(false);
      });
  };

  useEffect(() => {
    checkThisCampaignHasCoupon();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignID, token]);

  // Sözleşme başlıklarının biçimi
  const formattedTitles =
    agreements.length > 0
      ? agreements.length === 1
        ? agreements[0].title
        : agreements.length === 2
          ? `${agreements[0].title} ve ${agreements[1].title}`
          : agreements
            .slice(0, -2)
            .map((i) => i.title)
            .join(', ') +
          ', ' +
          `${agreements[agreements.length - 2].title} ve ${agreements[agreements.length - 1].title}`
      : '';

  // Kupon mu QR mı?
  const shouldShowCouponInsteadOfQR = useMemo(() => {
    if (!campaign) return false;
    if (campaign?.hasForm === '1') return false;
    const isDepleted = campaignHadCoupon === true && campaignHasCoupon === false;
    if (campaignHasCoupon === null) return false; // yükleniyor
    return !isDepleted && campaignHasCoupon === true;
  }, [campaign, campaignHasCoupon, campaignHadCoupon]);

  // Kupon alma
  const handleGetCampaignCoupon = () => {
    setCouponError('');
    setCouponLoading(true);
    setCouponData(null);

    if (!poiID) {
      setCouponError('POI bilgisi alınamadı. Lütfen sayfayı yenileyip tekrar deneyin.');
      setCouponModalOpen(true);
      setCouponLoading(false);
      return;
    }
    Services.GetNewCampaignCoupon(token, companyID, campaignID, poiID)
      .then((r) => {
        if (r?.data?.status) {
          setCouponData(r.data.result || r.data);
          setCouponModalOpen(true);
          checkThisCampaignHasCoupon();
          createShowQrLog()
        } else {
          setCouponError('Kupon alınamadı. Lütfen tekrar deneyin.');
          setCouponModalOpen(true);
        }
      })
      .catch(() => {
        setCouponError('Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.');
        setCouponModalOpen(true);
      })
      .finally(() => setCouponLoading(false));
  };

  const createShowQrLog = () => {
    Services.CreateBolParaQRShowLog(token, campaignID, poiID)
      .then((r) => {
        console.log(r)
      })
  }

  // Kupon içerik render
  const renderCouponContent = () => {
    if (couponLoading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
          <CircularProgress />
        </div>
      );
    }
    if (couponError) {
      return <p style={{ color: '#e11d48', fontSize: 14 }}>{couponError}</p>;
    }
    if (!couponData) {
      return <p style={{ color: '#64748B', fontSize: 12 }}>Gösterilecek kupon bulunamadı.</p>;
    }

    const code = couponData.code || couponData.couponCode || couponData.CouponCode;
    const title = couponData.title || campaign?.title || 'Kupon';
    const description = couponData.description || couponData.desc;
    const expireDate = couponData.expireDate || couponData.expiration || couponData.validUntil;
    const qrUrl = couponData.qrUrl || couponData.qrCodeUrl || couponData.qr;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h3 style={{ margin: 0 }}>{title}</h3>
        {description && <p style={{ color: '#475569', margin: 0 }}>{description}</p>}
        {code && (
          <>
            <div
              style={{
                background: '#f1f5f9',
                border: '1px dashed #94a3b8',
                padding: '12px 16px',
                borderRadius: 8,
                fontWeight: 700,
                letterSpacing: 1.2,
                textAlign: 'center',
              }}
            >
              {code}
            </div>
            {campaign?.title === 'İndirim Kodu' && (
              <p>Avon.com.tr üzerinden yapılan 600 TL  ve üzeri alışverişlerde geçerlidir. İndirim Kodları tek kullanımlıktır.</p>
            )}
          </>
        )}
        {expireDate && (
          <p style={{ color: '#64748B', fontSize: 12, margin: 0 }}>
            Son Kullanım: {expireDate}
          </p>
        )}
        {qrUrl && (
          <img src={qrUrl} alt="Kupon QR Kodu" style={{ alignSelf: 'center', maxWidth: 220, height: 'auto' }} />
        )}
        {!code && !description && !qrUrl && (
          <pre
            style={{
              background: '#0f172a',
              color: '#e2e8f0',
              padding: 12,
              borderRadius: 8,
              maxHeight: 300,
              overflow: 'auto',
            }}
          >
            {JSON.stringify(couponData, null, 2)}
          </pre>
        )}
      </div>
    );
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: '35%' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      {campaign && (
        <>
          {campaign.images && (
            <Carousel
              showStatus={false}
              showArrows={false}
              autoPlay
              interval={3000}
              infiniteLoop
              showThumbs={false}
              showIndicators={false}
            >
              {campaign.images.map((image, idx) => (
                <Box key={idx} component="img" src={image} sx={{ width: '25% !important', borderRadius: 2 }} />
              ))}
            </Carousel>
          )}

          {agreements.length > 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 4, width: '90%' }}>
              <Checkbox
                checked={termsAccepted}
                onClick={() => {
                  if (!termsAccepted) {
                    setIsTermsModalOpen(true);
                    setCurrentAgreementIndex(0);
                  } else {
                    setTermsAccepted(false);
                    setCurrentAgreementIndex(0);
                  }
                }}
              />
              <Typography sx={{ ml: 1 }}>{formattedTitles}</Typography>
            </Box>
          )}

          {shouldShowCouponInsteadOfQR ? (
            <Button
              variant="contained"
              sx={{ mt: '5%', width: 236 }}
              onClick={handleGetCampaignCoupon}
              disabled={(agreements.length > 0 && !termsAccepted) || couponLoading}
            >
              {couponLoading ? 'Kod alınıyor...' : 'İndirim Kodu Ver'}
            </Button>
          ) : (
            <Button
              variant="contained"
              sx={{ mt: '5%', width: 236 }}
              onClick={() => { setIsQrModalOpen(true); createShowQrLog(); }}
              disabled={agreements.length > 0 && !termsAccepted}
            >
              QR Kodu Görüntüle
            </Button>
          )}

          <Box sx={{ p: 2 }}>
            <Box sx={{ alignSelf: 'flex-start', mb: '50%' }}>
              <Box dangerouslySetInnerHTML={{ __html: campaign.description }} sx={{ whiteSpace: 'pre-wrap' }} />
            </Box>
          </Box>

          {/* QR Modal */}
          <Modal open={isQrModalOpen} onClose={() => setIsQrModalOpen(false)}>
            <Box
              sx={{
                height: 350,
                width: 350,
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                borderRadius: 2,
                p: 2,
              }}
            >
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <IconButton onClick={() => setIsQrModalOpen(false)}>
                  <Iconify icon="material-symbols:close" />
                </IconButton>
              </Box>

              <Box
                sx={{
                  bgcolor: 'black',
                  mt: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 169,
                  height: 169,
                  borderRadius: 1,
                  mx: 'auto',
                }}
              >
                <Box
                  component="img"
                  sx={{ width: 147 }}
                  src={`https://qr.easypointapi.com/?chl=https://bolpara.easypoint.com.tr?token=${token}:${campaignID}`}
                  alt="QR Code"
                />
              </Box>

              <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <a
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    marginTop: 14,
                    textAlign: 'center',
                    alignSelf: 'center',
                  }}
                  href={`https://bolpara.easypoint.com.tr?token=${token}:${campaignID}`}
                >
                  Forma gitmek için tıklayın
                </a>
              </Box>

              <Typography variant="body2" sx={{ textAlign: 'center', color: '#64748B', mt: 2 }}>
                ya da
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center', color: '#64748B' }}>
                QR Kodu
              </Typography>
              <Typography variant="caption" sx={{ textAlign: 'center', color: '#64748B', display: 'block', mt: 1 }}>
                Müşterinizin başvuru formuna ulaşması için QR Kodu okutmasını isteyiniz.
              </Typography>
            </Box>
          </Modal>

          {/* Terms Modal */}
          <Modal open={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)}>
            <Box
              sx={{
                width: '45%',
                p: 3,
                mt: '10%',
                mx: 'auto',
                bgcolor: 'background.paper',
                borderRadius: 2,
                maxHeight: '70%',
                overflowY: 'auto'
              }}
            >
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <IconButton
                  onClick={() => {
                    setIsTermsModalOpen(false);
                    setCurrentAgreementIndex(0);
                  }}
                >
                  <Iconify icon="material-symbols:close" />
                </IconButton>
              </Box>

              <Box sx={{ flex: 1, mt: 1, overflowY: 'auto', width: '100%' }}>
                <Box
                  dangerouslySetInnerHTML={{ __html: agreements[currentAgreementIndex]?.content }}
                  sx={{ whiteSpace: 'pre-wrap' }}
                />
              </Box>

              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => {
                  if (currentAgreementIndex < agreements.length - 1) {
                    setCurrentAgreementIndex((p) => p + 1);
                  } else {
                    setTermsAccepted(true);
                    setIsTermsModalOpen(false);
                  }
                }}
              >
                Koşulları Kabul Ediyorum
              </Button>
            </Box>
          </Modal>

          {/* Kupon Modal */}
          <Modal open={couponModalOpen} onClose={() => setCouponModalOpen(false)}>
            <Box
              sx={{
                width: 320,
                p: 2,
                mt: '10%',
                mx: 'auto',
                bgcolor: 'background.paper',
                borderRadius: 2,
              }}
            >
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <IconButton onClick={() => setCouponModalOpen(false)}>
                  <Iconify icon="material-symbols:close" />
                </IconButton>
              </Box>
              <Box sx={{ width: '100%', mt: 1 }}>{renderCouponContent()}</Box>
            </Box>
          </Modal>
        </>
      )}
    </Box>
  );
}